import { RefObject } from 'react';

export const triggerUploadOnButtonClick = (
  inputRef: RefObject<HTMLInputElement>
): (() => void) => {
  return () => {
    inputRef.current?.click();
  };
};
